import { render } from "./Question.vue?vue&type=template&id=48ca9c2c&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=48ca9c2c&scoped=true&lang=css"

import exportComponent from "C:\\Assembla\\VIV0006\\root\\dev\\QuizWhiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ca9c2c"]])

export default __exports__